module.exports = __webpack_public_path__ + "img/WOORIBANK.f337c5c7.svg";